import { HeaderBarBannerData } from '../../../common/apiAdapters/types';

export const SHOW_BANNER = 'SHOW_BANNER';
export const HIDE_BANNER = 'HIDE_BANNER';
export const SET_BANNER_DATA = 'SET_BANNER_DATA';
export const FETCH_BANNER_DATA = 'FETCH_BANNER_DATA';
export const HEADER_BAR_BANNER_COOKIE = 'is_header_bar_banner_dismissed';

export enum Banners {
    HEADER_BAR_BANNER = 'HEADER_BAR_BANNER',
}

export interface BannerInterface {
    data?: {};
    dismissed: boolean;
}

export interface HeaderBarBanner extends BannerInterface {
    data?: HeaderBarBannerData;
}

export interface SetBannerDataAction {
    type: typeof SET_BANNER_DATA;
    payload: HeaderBarBannerData;
    identifier: Banners;
}

export interface FetchBannerDataAction {
    type: typeof FETCH_BANNER_DATA;
    identifier: string;
}

export interface ShowBannerAction {
    type: typeof SHOW_BANNER;
    identifier: Banners;
}

export interface HideBannerAction {
    type: typeof HIDE_BANNER;
    identifier: Banners;
}

export type BannersState = {
    [Banners.HEADER_BAR_BANNER]: HeaderBarBanner;
};

export type BannerActionTypes = ShowBannerAction | HideBannerAction | SetBannerDataAction;
